<template>
    <div>
        <v-row>
            <v-col class="py-5" cols="6" sm="4" v-for="(n, index) in contents" :key="index + 'former'">
                <v-img
                max-height="185" contain
                :src="`${$url}/downloadfile/${n.Files[0] ? n.Files[0].ID : ''}`"
                class="transparent lighten-2 mb-3"
                >
                    <template v-slot:placeholder>
                    <v-layout
                        fill-height
                        align-center
                        justify-center
                        ma-0
                        >
                        <v-progress-circular indeterminate color="grey lighten-1"></v-progress-circular>
                    </v-layout>
                    </template>
                </v-img>
                <p class="subheading text-center" v-html="n.Title"></p>
                <p class="ma-0 caption attorney-dates  text-center" v-html="n.Body" ></p>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    export default {
        props: ['contents']
    }
</script>